<template>
  <v-container v-if="user" fluid>
    <v-card class="pa-3">
      <v-card-title>
        Localizacion GPS
        <v-spacer />
      </v-card-title>
      <v-row>
        <v-col>
          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'UbicacionEnVivo',
                'enabled-button': currentView === 'UbicacionEnVivo',
              },
              'mr-1',
              'ml-3',
              'mb-3',
            ]"
            color="primary"
            @click="currentView = 'UbicacionEnVivo'"
          >
            Ubicación en Vivo
          </v-btn>
          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'VisitasGps',
                'enabled-button': currentView === 'VisitasGps',
              },
              'mr-1',
              'ml-3',
              'mb-3',
            ]"
            color="primary"
            @click="currentView = 'VisitasGps'"
          >
            Visitas
          </v-btn>
        </v-col>
      </v-row>
      <VisitasGps v-if="currentView === 'VisitasGps'" />
      <UbicacionEnVivo v-if="currentView === 'UbicacionEnVivo'" />
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VisitasGps from "./VisitasGps.vue";
import UbicacionEnVivo from "./UbicacionEnVivo.vue";
export default {
  components: {
    VisitasGps,
    UbicacionEnVivo,
  },
  data() {
    return {
      currentView: "UbicacionEnVivo",
      items: [],
    };
  },
  methods: {
    async getUsuarios() {
      try {
        const usuarios = await axios.get("/usuarios/get_usuarios");
        this.items = usuarios.data.usuarios;
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getUsuarios();
  },
  computed: {
    ...mapGetters(["user"]),
    itemsNombre() {
      return this.items.map((usuario) => {
        if (usuario.sucursal === "LaPaz") {
          usuario.sucursal = "La Paz";
        }
        //Se modifica la propiedad de permisos de cada usuario para que no interfiera con las busquedas en la tabla
        // if (usuario.permisos) {
        //   usuario.permisos = {
        //     permisos_disponibles: usuario.permisos.split(" "),
        //   };
        // }

        return usuario;
      });
    },
  },
};
</script>
